<template>
  <v-container fluid no-gutters class="my-0 py-0">
    <v-row justify="center" align="center">
      <v-col cols=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
        <v-img
            class="white--text align-end"
            height="auto"
            width="100vw"
            contain
            :src="require('@/assets/PARON-CARD.jpg')"
        />
      </v-col>
    </v-row>
    <div class="about-wrap">
      <v-skeleton-loader v-if="!about" type="article, paragraph, paragraph" class="about-content" />
      <div v-else class="about-content" v-html="renderedAbout"></div>
      <div class="about-cta">
        <v-btn color="#1b2f5a" dark large depressed to="/Partners">
          Δείτε τις εκπτώσεις<v-icon right small>mdi-arrow-right</v-icon>
        </v-btn>
        <v-btn color="#1b2f5a" outlined large to="/Register">Αποκτήστε την κάρτα</v-btn>
      </div>
    </div>
  </v-container>
</template>


<script>
  import pages from "@/services/pages"

  export default {
    data() {
        return {
            about: null
        }
    },
    computed: {
      renderedAbout() {
        if (!this.about) {
          return ''
        }
        return this.normalizeRichText(this.about)
      },
    },
    created() {
        this.fetchAbout()
    },
    methods: {
      getImage() {
        return require('@/assets/LOGOPARON 2023.png')
        
      },
      fetchAbout() {
        pages.getAbout()
          .then(response => {
            this.about = response.data[0].description
          })
          .catch(error => {
            console.log(error)
          })
      },
      normalizeRichText(value) {
        let html = (value || '').toString().trim()

        // Remove markdown code fences if content was pasted from chat/code blocks.
        html = html.replace(/^```(?:html)?\s*/i, '').replace(/\s*```$/, '')

        // Decode escaped HTML entities, e.g. &lt;div&gt;...&lt;/div&gt;
        if (html.includes('&lt;') || html.includes('&gt;') || html.includes('&amp;')) {
          const decoder = document.createElement('textarea')
          decoder.innerHTML = html
          html = decoder.value
        }

        return this.tidy(html)
      },
      // The CMS text is laid out with inline paddings, &nbsp; spacers and bold divs as headings.
      // Turn it into plain structure so the page styles below decide the look.
      tidy(html) {
        const root = document.createElement('div')
        root.innerHTML = html
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
        const blanks = []
        while (walker.nextNode()) {
          // trim() also strips &nbsp;
          if (!walker.currentNode.nodeValue.trim()) {
            blanks.push(walker.currentNode)
          }
        }
        blanks.forEach(node => node.remove())
        root.querySelectorAll('br + br, div > br:first-child').forEach(node => node.remove())

        root.querySelectorAll('div[style]').forEach(div => {
          const style = div.getAttribute('style') || ''
          if (/border\s*:/.test(style)) {
            div.classList.add('about-callout')
          } else if (/font-weight:\s*bold/.test(style) && /font-size:\s*2\dpx/.test(style)) {
            const heading = document.createElement(/underline/.test(style) ? 'strong' : 'h2')
            heading.innerHTML = div.innerHTML
            div.replaceWith(heading)
            return
          } else if (/max-width/.test(style)) {
            div.classList.add('about-section')
          }
          div.removeAttribute('style')
        })
        root.querySelectorAll('p[style], li[style], ol[style], ul[style]').forEach(node => node.removeAttribute('style'))
        // a callout wrapped in a centring div: drop the extra wrappers
        root.querySelectorAll('.about-callout').forEach(box => {
          const inner = box.firstElementChild
          if (inner && box.children.length === 1 && inner.tagName === 'DIV') {
            box.innerHTML = inner.innerHTML
          }
        })
        return root.innerHTML
      },
    }
  }
</script>

<style lang="scss" scoped>
    .about-wrap {
      max-width: 940px;
      margin: -48px auto 64px;
      padding: 0 18px;
      position: relative;
    }

    .about-content {
      padding: 40px 48px;
      background: #fff;
      border: 1px solid rgba(27, 47, 90, 0.1);
      border-radius: 18px;
      box-shadow: 0 12px 32px rgba(27, 47, 90, 0.1);
      color: #1b2f5a;
      font-size: 16px;
      line-height: 1.75;
    }

    .about-content ::v-deep .about-section + .about-section {
      margin-top: 32px;
      padding-top: 32px;
      border-top: 1px solid rgba(27, 47, 90, 0.1);
    }

    .about-content ::v-deep h2 {
      margin: 24px 0 10px;
      font-size: 21px;
      font-weight: 700;
      line-height: 1.3;
    }

    .about-content ::v-deep .about-section > h2:first-child,
    .about-content ::v-deep .about-section > div:first-child > h2:first-child,
    .about-content ::v-deep .about-section > div:first-child > div:first-child > h2:first-child {
      margin-top: 0;
    }

    .about-content ::v-deep p {
      margin: 0 0 12px;
    }

    .about-content ::v-deep ol,
    .about-content ::v-deep ul {
      margin: 8px 0 12px;
      padding-left: 22px;
    }

    .about-content ::v-deep li {
      margin-bottom: 8px;
    }

    .about-content ::v-deep li::marker {
      color: #ad282d;
      font-weight: 700;
    }

    .about-content ::v-deep a {
      color: #ad282d;
    }

    .about-content ::v-deep img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }

    .about-content ::v-deep .about-callout {
      margin: 16px 0;
      padding: 18px 22px;
      border-left: 4px solid #ad282d;
      border-radius: 12px;
      background: rgba(173, 40, 45, 0.06);
      text-align: left;
    }

    .about-content ::v-deep .about-callout strong:first-child {
      display: block;
      margin-bottom: 4px;
      color: #8f1f23;
      font-size: 17px;
    }

    .about-cta {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 12px;
      margin-top: 32px;
    }

    @media (max-width: 700px) {
      .about-wrap {
        margin-top: -20px;
      }

      .about-content {
        padding: 24px 20px;
        border-radius: 14px;
        font-size: 15px;
      }
    }
</style>
